import { BaseService } from "@/api/baseService";
import type { Page, ReceivePayment, ScheduleDateVo, ScheduleForm } from "@zhihaoscm/entity";
import httpRequest from "@/api/index";

export class ScheduleService extends BaseService<ScheduleDateVo, ScheduleDateVo, ScheduleForm, unknown> {
    // 获取印章列表
    async customPaging(params: unknown): Promise<Page<ScheduleDateVo>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    // 根据排期日期查询并分组
    async scheduleDate(params: unknown): Promise<ScheduleDateVo[]> {
        const { data } = await this.service.get(`${this.path}/schedule-date`, { params });
        return data;
    }

    // 确认-确认并支付
    async confirmAndPay(id: string, params: unknown): Promise<ReceivePayment> {
        const { data } = await this.service.put(`${this.path}/confirm/${id}`, params);
        return data;
    }

    // 确认
    async confirm(id: string, params: unknown): Promise<ScheduleDateVo[]> {
        const { data } = await this.service.put(`${this.path}/confirm/${id}`, params);
        return data;
    }

    // 确认-确认并支付线下
    async confirmOffLine(
        id: string,
        params: {
            receivePaymentId: string;
            fileIds: (number | string)[];
            paymentInstruction?: string;
        }
    ): Promise<ScheduleDateVo[]> {
        const { data } = await this.service.put(`${this.path}/confirmOffLine/${id}`, params);
        return data;
    }
}

export const scheduleService = new ScheduleService("/schedule", httpRequest);
